import { render, staticRenderFns } from "./manyType.vue?vue&type=template&id=44b99641&scoped=true&"
import script from "./manyType.vue?vue&type=script&lang=js&"
export * from "./manyType.vue?vue&type=script&lang=js&"
import style0 from "./manyType.vue?vue&type=style&index=0&id=44b99641&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b99641",
  null
  
)

export default component.exports